export const TRADING_OPTION = [
  // {
  //   heading: "Equity",
  //   name: "equity",
  //   para: "By selecting this option you can trade in NSE & BSE equity market",
  // },
  {
    heading: "Trading",
    name: "close_trading_account",
    // para: "By selecting this option you can trade in MCX Market",
  },
  {
    heading: "Demat",
    name: "close_demat_account",
    // para: "By selecting this option you can trade in NSE & BSE futures and options ",
  },
];
